<template>
  <section class="personal-projects">
    <div class="page-container">
      <div class="title-container" id="personal-projects">
        <img class="title-icon" src="@/assets/navbar/personal_icon.png" alt="Icon">
        <h1 class="title">{{ $t('personal-projects.personal-projects') }}</h1>
      </div>
    </div>

    <GamesCarousel :games="PersonalGames" />

  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import PersonalGamesEn from '@/components/Helpers/PersonalGames/PersonalGamesEn.js';
import PersonalGamesPt from '@/components/Helpers/PersonalGames/PersonalGamesPt.js';
import GamesCarousel from '@/components/Helpers/GamesCarousel.vue';

const PersonalGames = ref(null);

onMounted(() => {
  checkLanguage();
});

function checkLanguage() {
  const userLanguage = navigator.language || navigator.userLanguage;

  if (userLanguage.startsWith("pt")) {
    PersonalGames.value = PersonalGamesPt;
  }
  else {
    PersonalGames.value = PersonalGamesEn;
  }
}
</script>

<style lang="scss" scoped>
@import '~/src/assets/css/ProjectsHeaderStyle.scss';

.personal-projects {
  margin-top: 45px;
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  padding-bottom: 20px;
}
</style>